import { useEffect } from 'react';
import { StatusSymbol } from '@leoradating/ui';
import styles from './styles.module.scss';
import { useRouter } from '@tanstack/react-router';
import { useSearchParams } from '@/hooks/useSearchParams';

export const NotFoundScene = () => {
  const router = useRouter();
  const { createSearchParams } = useSearchParams();

  useEffect(() => {
    const redirectInterval = setInterval(() => {
      router.navigate({
        to: '/login',
        search: createSearchParams({}, true),
      });
    }, 3000);

    return () => clearInterval(redirectInterval);
  }, []);

  return (
    <div className={styles.scene} role="status">
      <StatusSymbol
        icon="QuestionMarkCircleIcon"
        heading="Page not found"
        body="We couldn't find that page. You'll be taken to sign in shortly."
      />
    </div>
  );
};
